'use strict';

import React, { Fragment } from 'react';

const ExternalIcon = ({ isExternal, children }) => {
    if (!isExternal) {
        return <span>{children}</span>;
    }

    return (
        <Fragment>
            <span className="play_link-external__icon" aria-hidden="true"></span>
            {children}
            <span className="play_visually-hidden">, öppnar annan webbplats</span>
        </Fragment>
    );
};

export default ExternalIcon;
